module.exports = __webpack_public_path__ + "books@2x.jpg";